// Topic slugs to exclude from topic lists
export const EXCLUDED_TOPIC_SLUGS: string[] = ['biorxiv-community-reviews'];
